export default {
  getContacts: 'getcontacts?srid={supplyRequestId}',
  getContactsByCustomerAndService:
    'getcontactsbycustomerandservice?crmid={customerId}&svcid={serviceId}',
  updateAssignedContacts: 'updateassignedcontacts'
}
